var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 0.583374C11.081 0.583374 11.4167 0.91916 11.4167 1.33337V1.91672H12.6667C13.8173 1.91672 14.75 2.84946 14.75 4.00005V6.66672V13.3334C14.75 14.484 13.8173 15.4167 12.6667 15.4167H3.33333C2.18274 15.4167 1.25 14.484 1.25 13.3334V6.66672V4.00005C1.25 2.84946 2.18274 1.91672 3.33333 1.91672H4.58337V1.33337C4.58337 0.91916 4.91916 0.583374 5.33337 0.583374C5.74759 0.583374 6.08337 0.91916 6.08337 1.33337V1.91672H9.91675V1.33337C9.91675 0.91916 10.2525 0.583374 10.6667 0.583374ZM4.58337 3.41672V4.00004C4.58337 4.41425 4.91916 4.75004 5.33337 4.75004C5.74759 4.75004 6.08337 4.41425 6.08337 4.00004V3.41672H9.91675V4.00004C9.91675 4.41425 10.2525 4.75004 10.6667 4.75004C11.081 4.75004 11.4167 4.41425 11.4167 4.00004V3.41672H12.6667C12.9888 3.41672 13.25 3.67788 13.25 4.00005V5.91672H2.75V4.00005C2.75 3.67788 3.01117 3.41672 3.33333 3.41672H4.58337ZM13.25 7.41672V13.3334C13.25 13.6556 12.9888 13.9167 12.6667 13.9167H3.33333C3.01117 13.9167 2.75 13.6556 2.75 13.3334V7.41672H13.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.79145b6b477bc29c6928d96d21f4aa2d.svg";
export { ForwardRef as ReactComponent };